// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import store from './store';
import Fingerprint2 from 'fingerprintjs2';
// 引入 jquery
/* eslint-disable no-unused-vars */
import $ from 'jquery';
// 引入复制内容到粘贴板的插件
import VueClipboard from 'vue-clipboard2';
// 引入element-ui组件库
import ElementUI from 'element-ui';
// 引入移动端日历
import Calendar from 'vue-mobile-calendar';

import 'element-ui/lib/theme-chalk/display.css';
import 'chimee-player/lib/chimee-player.browser.css';
import 'chimee-mobile-player/lib/chimee-mobile-player.browser.css';
import './style/_elementui.scss';
// 引入公共样式文件
import './style/style.scss';
import './style/font.scss';
// 引入字体图标
import './style/iconfont.scss';
import { mainService } from 'services/liveManage.main.js';

// 使用配置文件规则
axios.defaults.withCredentials = true;
Vue.prototype.$http = axios;

Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.use(Calendar);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  // 移动端，切换路由时解除滚动事件的绑定
  if (window.innerWidth < 768) {
    window.onscroll = null;
  }
  document.onkeydown = null;
  // 如果跳转到首页的话，判断是否处于登录状态，如果登录的话，直接跳转到管理员页面。
  if (to.path === '/homePage') {
    mainService.checkLogin().then(res => {
      if (res.data.status === 2) {
        next('/liveManage/livingManage');
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

/*
* 拦截器，当登陆失效时，进行跳转
* */
axios.interceptors.response.use(
  response => {
    if (response.data.status === 1 && response.data.msg === 'fail') {
      ElementUI.Message({message: '登录超时，请重新登录', type: 'warning'});
      store.commit('isLogins', false);
      sessionStorage.removeItem('isLogin');
      router.push({path: '/'});
    }
    return response;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400: err.message = '请求错误'; break;
        case 401: err.message = '未授权，请登录'; break;
        case 403: err.message = '拒绝访问'; break;
        case 404: err.message = `请求地址出错: ${err.response.config.url}`; break;
        case 408: err.message = '请求超时'; break;
        case 500: err.message = '服务器内部错误'; break;
        case 501: err.message = '服务未实现'; break;
        case 502: err.message = '网关错误'; break;
        case 503: err.message = '服务不可用'; break;
        case 504: err.message = '网关超时'; break;
        case 505: err.message = 'HTTP版本不受支持'; break;
        default:
      }
      if (err.response.data) {
        return Promise.reject(err.response.data); // 返回接口返回的错误信息
      }
    }
  }
);

if (!sessionStorage.getItem('uaUniqueId')) {
  Fingerprint2.get(function (components) {
    const values = components.map(function (component, index) {
      if (index === 0) { // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
        return component.value.replace(/\bNetType\/\w+\b/, '');
      }
      return component.value;
    });
    // 生成最终id murmur
    const murmur = Fingerprint2.x64hash128(values.join(''), 31);
    sessionStorage.setItem('uaUniqueId', murmur);
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  render: h => h(App)
});

Vue.mixin({
  beforeRouteLeave (to, from, next) {
    console.log(to.path);
    let str = '';
    if (from.path.indexOf('liveManage') > -1) {
      str = 'liveManage';
    } else {
      if (from.name !== 'liveShow') {
        str = from.name;
        console.log(str);
      }
    }
    if (to.path === '/liveShow' || to.path === '/liveShowDetails' || to.path === '/liveColumn' || to.path === '/homeLive' || to.path === '/homeLiveColumn') {
      this.$store.commit('setCacheList', str);
      console.log(this.$store.state.cacheList);
      // next();
    } else if (to.path === '/homePage') {
      this.$store.commit('setCacheList', 'kong');
      // next(false);
    }
    if (to.path === '/liveShow' && to.query.link) {
      window.location.href = to.query.link;
      return false;
    }
    next();
  }
});



// WEBPACK FOOTER //
// ./src/main.js